import { render, staticRenderFns } from "./IpswichCity.vue?vue&type=template&id=b3ea7010&scoped=true&"
import script from "./IpswichCity.vue?vue&type=script&lang=js&"
export * from "./IpswichCity.vue?vue&type=script&lang=js&"
import style0 from "./IpswichCity.vue?vue&type=style&index=0&id=b3ea7010&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ea7010",
  null
  
)

export default component.exports